import {Stack,} from '@mantine/core';
import {PaymentIntent,} from '../types';
import {PlatformPropertyCard} from '@flexinet/ui-components';
import {StripeAmount} from "../../../components/StripeAmount.tsx";
import {CustomerLink} from '../../customers/links/CustomerLink.tsx';


export const Profile = ({record}: { record: PaymentIntent }) => {

    const properties = [
        {
            label: 'Amount',
            value: <StripeAmount amount={record.amount} currency={record.currency}/>,
            span: 12,
        }, {
            label: 'Description',
            value: record.description as string,
            span: 12,
        }, {
            label: 'Customer',
            value: <CustomerLink record={{
                id: record.customerId,
                name: record.customerId
            }}></CustomerLink>,
            span: 12,
        }, {
            label: 'Status',
            value: record.status,
            span: 12,
        }, {
            label: 'Client Secret',
            value: record.clientSecret,
            span: 12,
        }, {
            label: 'Payment Method',
            value: record.paymentMethod as string,
            span: 12,
        }];

    const properties2 = [
        {
            label: 'ID',
            value: record.id,
            span: 12,
        }];

    return (
        <Stack gap={'xl'}>
            <PlatformPropertyCard properties={properties}/>
            <PlatformPropertyCard properties={properties2}/>
        </Stack>
    );


};
